import { render, staticRenderFns } from "./CompareConfigsByVer.vue?vue&type=template&id=366f67e7"
import script from "./CompareConfigsByVer.vue?vue&type=script&lang=js"
export * from "./CompareConfigsByVer.vue?vue&type=script&lang=js"
import style0 from "./CompareConfigsByVer.vue?vue&type=style&index=0&id=366f67e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports